<script>
import { mapActions, mapGetters } from 'vuex'
import AppModalNotificacao from '@/screens/portal/seguranca/components/AppModalNotificacao'
import layoutPage from '@/components(new)/layout/LayoutBases/LayoutCentral/LayoutCentral.vue'

export default {
  components: {
    AppModalNotificacao,
    layoutPage
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    getUrlTermo () {
      return process.env.BASE_URL + '#/termo-de-uso'
    },
    getUrlPolitica () {
      return process.env.BASE_URL + '#/aviso-de-privacidade'
    }
  },

  data () {
    return {
      textoTermo: '',
      aceito: false
    }
  },

  async created () {
    if (this.usuario.isTermoAceito) {
      this.$router.push({ name: 'selecionarModulo' })
    }
  },

  methods: {
    ...mapActions({
      setTermoDeAceite: 'usuario/setTermosAceitos'
    }),
    async aceitaTermos () {
      try {
        await this.setTermoDeAceite()
        this.$router.push({ name: 'selecionarModulo' })
      } catch (e) {
        console.error(e.message)
      }
    }
  }
}
</script>

<template>
   <layoutPage>
     <div class="text-center">
       <main class="container card text-center">
         <div class="title">
            <span><b>Termos de Uso e Privacidade</b></span>
          </div>
          <span>Para continuar, você precisa ler e aceitar nossos
            <a :href="getUrlTermo" target="_blank">termos de uso</a> e
            <a :href="getUrlPolitica" target="_blank">aviso de privacidade</a>.
          </span>
          <div class="container-checkbox">
            <el-checkbox v-model="aceito" class="checkbox">
              Declaro que li e estou ciente e de acordo com as normas
              apresentadas.
            </el-checkbox>
          </div>
        </main>
        <el-button type="success" class="button-acordo" :disabled="!aceito" @click="aceitaTermos()">
          Li e estou de acordo
        </el-button>
      </div>
  </layoutPage>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/termos/termos.vue